import { FC } from 'react';

import { ArrowIcon, HighFiveHandsIcon } from 'assets';
import { Button } from 'view/components';
import * as S from 'view/modals/OnboardingWizard/styled';

interface IntroStepProps {
  onNext: () => void;
  onBack: () => void;
}

const RecruiterIntroStep: FC<IntroStepProps> = ({ onNext, onBack }) => {
  return (
    <S.WizardContent>
      <S.StepImage>
        <HighFiveHandsIcon />
      </S.StepImage>
      <S.StepHeader>
        <S.StepTitle>Let&apos;s Set up Your Hiring Profile</S.StepTitle>
        <S.StepSubtitle>
          Your profile helps us connect you with the right candidates for your hiring needs
        </S.StepSubtitle>
      </S.StepHeader>
      <S.WizardFooter>
        <Button variant="outlined" text="Back" onClick={onBack} />
        <Button
          variant="contained"
          text="Set up profile"
          onClick={onNext}
          endIcon={<ArrowIcon rotate="right" color="#FFFFFF" />}
        />
      </S.WizardFooter>
    </S.WizardContent>
  );
};

export default RecruiterIntroStep;
